"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialize = initialize;
function initialize(element) {
    var headers = [];

    if (!element) {
        headers = Array.from(document.querySelectorAll(".dropdown .dropdown__header"));
    } else if (Array.isArray(element)) {
        headers = Array.from(element);
    } else {
        headers.push(element);
    }

    if (headers) {
        headers.forEach(function (header) {
            var parent = header.parentElement;
            var body = parent.querySelector(".dropdown__content");
            header.addEventListener("click", function (event) {
                if (body.classList.contains("dropdown__content--show")) {
                    body.classList.remove("dropdown__content--show");
                    header.classList.remove("shown");

                    //For not showing draggable section when droppedown any container
                    if (header.closest(".sortable") && header.closest(".sortable").parentElement.querySelectorAll(".dropdown__content--show.dropdown__content--show").length === 0) {
                        header.closest(".sortable").parentElement.classList.remove("dropped-container");
                    }
                } else {
                    body.classList.add("dropdown__content--show");
                    header.classList.add("shown");

                    //For not showing draggable section when droppedown any container
                    if (header.closest(".sortable")) {
                        header.closest(".sortable").parentElement.classList.add("dropped-container");
                    }
                }
            }, true);
        });
    }
}